<template>
    <div class="tw-bg-white tw-rounded-md tw-p-8 tw-max-w-sm tw-mx-auto tw-mt-8 tw-text-center">
        {{ $t("appErrors.chunkLoadFailureInfo") }}
        <div v-if="reloadAmount <= 3" class="tw-mt-8 tw-text-sm tw-font-semibold">
            {{ $t("appErrors.chunkLoadFailureAutomaticRetry") }} {{ refreshInSeconds }} ...
        </div>
        <button
            class="tw-w-full tw-mt-8 tw-inline-flex tw-justify-center tw-items-center tw-px-4 tw-py-2 tw-border tw-border-transparent tw-text-sm tw-font-bold tw-rounded-md tw-shadow-sm tw-text-white tw-bg-indigo-500 hover:tw-bg-indigo-600"
            type="button"
            @click="onReload"
        >
            {{ $t("appErrors.chunkLoadFailureButtonAction") }}
        </button>
    </div>
</template>

<script>
import api from "@/api";

const PAGE_RELOAD_KEY = "pageReloadsOnError";

export default {
    data() {
        return {
            refreshInSeconds: 10,
            interval: null,
            reloadAmount: 0,
        };
    },
    async mounted() {
        this.reloadAmount = parseInt(window.sessionStorage.getItem(PAGE_RELOAD_KEY) ?? 0, 10);

        // Some dashboards / bots appear to get stuck in automated retries which messes up our event stats.
        // We'd like to prevent this and fall back to manual only mode after 3 retries.
        if (this.reloadAmount <= 3) {
            this.interval = setInterval(() => {
                this.refreshInSeconds -= 1;
                if (this.refreshInSeconds <= 0) this.onReload();
            }, 1000);
        }

        try {
            // inform us that the user landed here and could not load the page
            await api.post("/api/application-feedback", {
                name: "appInitializationFailure",
                appFramework: "vue",
                context: "Navigation within the application",
            });
        } catch {
            // nice to have if API is running
        }
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    methods: {
        onReload() {
            window.sessionStorage.setItem(PAGE_RELOAD_KEY, this.reloadAmount + 1);

            if (
                this.$route.query.redirect &&
                this.$route.query.redirect !== "/error/chunk-load-failure"
            ) {
                window.location.hash = this.$route.query.redirect;
            } else {
                window.location.hash = "";
            }

            window.location.reload();
        },
    },
};
</script>
